export const REQUEST_AGREEMENT_STATUS = [
  { name: 'aprovada', value: 'approved' },
  { name: 'error', value: 'error' },
  { name: 'rechazada', value: 'reject' },
  { name: 'pendiente', value: 'pending' }
]

export const ADJUSTMENT_STATUS = [
  { name: 'Todos', value: '' },
  { name: 'Vigente', value: 'Vigente' },
  { name: 'Pendiente', value: 'Pendiente' },
  { name: 'Rechazado', value: 'Rechazado' },
  { name: 'No vigente', value: 'No vigente' }
]

export const TAGS_STATUS_COLOR = [
  { color: 'success', value: 'vigente' },
  { color: 'warning', value: 'pendiente' },
  { color: 'error', value: 'rechazado' },
  { color: 'default', value: 'no vigente' }
]

export const localStorageProviderId = 'd9f144a51454eae08eb84ab3ade674a5'
export const localStorageOrgCode = '9ed884dc691e20319b72c440905d3c45'
